const LEADING_QUOTES_REGEX = /^"[^"]+"(?:\s*,\s*"[^"]+")*/;
const QUOTE_CONTENT_REGEX = /"([^"]+)"/g;

/**
 * Extracts leading quoted segments from an evidence summary.
 *
 * Summaries for DocumentReferences may contain one or more comma-separated
 * quotes followed by metadata, e.g.:
 *   "Patient has diabetes" - Consult Note (retrieved 1/15/2026)
 *   "Part A", "Part B", "Part C" - Consult Note (retrieved 1/15/2026)
 *
 * Returns the text inside each leading quote in order, or an empty array if
 * the summary does not start with a quoted segment.
 */
export function extractQuotesFromSummary(summary: string | undefined): Array<string> {
  if (!summary) {
    return [];
  }
  const leadingMatch = summary.match(LEADING_QUOTES_REGEX);
  if (!leadingMatch) {
    return [];
  }
  const quotes: Array<string> = [];
  for (const match of leadingMatch[0].matchAll(QUOTE_CONTENT_REGEX)) {
    quotes.push(match[1]);
  }
  return quotes;
}
